module.exports = __webpack_public_path__ + "static/media/WEIPA TOWN.96e40dbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/WEIPA TOWN.svg
// module id = 589
// module chunks = 0